module.exports = __webpack_public_path__ + "img/unicorn-book_B096TLBHG4.d2518f28.jpg";